module.exports = __webpack_public_path__ + "static/media/powerbar.6005bdc9.png";